export const LINKS = {
  blog: 'https://blog.naver.com/logncoding1',
  youtube: 'https://www.youtube.com/channel/UChwDwT18lm409tFmpQq6EnA',
  kakao: 'https://pf.kakao.com/_nNBIn',
  instagram: 'https://www.instagram.com/logncoding/',
};
